import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxProductTypes from './cx-product-type.reducer';

export const cxProductTypeKey = 'cxProductTypes';
export const reducers = fromCxProductTypes.reducer;

export interface CxProductTypesState extends State {
  [cxProductTypeKey]: fromCxProductTypes.CxProductTypeState;
}

export const selectProductTypesState = createFeatureSelector<fromCxProductTypes.CxProductTypeState>(cxProductTypeKey);
